import { AccountApi, CorporateOfferApi, EnumOfferType } from '@blank/api'
import { Image } from 'modules/common/components/Image/Image'
import { RoundedElevatedCard } from 'modules/common/components/RoundedElevatedCard/RoundedElevatedCard'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { BankCardActivationCardButton } from './BankCardActivationCardButton'

interface Props {
  offer: CorporateOfferApi
  account: AccountApi
}

export const BankCardActivationCard = ({ offer, account }: Props) => {
  const { t } = useTranslation('home-components')

  return (
    <RoundedElevatedCard className="relative">
      <h3 className="mb-2">{t('bankCardActivationCard.title')}</h3>
      <div className="h-full">
        <div className="flex h-full flex-col">
          <p className="w-2/3 text-info-400">
            {t('bankCardActivationCard.description')}
          </p>
          <BankCardActivationCardButton account={account} />
        </div>
      </div>
      <div className="absolute bottom-0 right-0 h-[170px] w-[157px]">
        {offer.offerType === EnumOfferType.EXTENDED_CARD && (
          <Image
            alt="extended-card-img"
            src="/assets/img/home-extended-card.png"
            fill
          />
        )}
        {offer.offerType === EnumOfferType.BASIC_CARD && (
          <Image
            alt="basic-card-img"
            src="/assets/img/home-basic-card.png"
            fill
          />
        )}
      </div>
    </RoundedElevatedCard>
  )
}
